"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.runLater = exports.sleep = exports.later = exports.wait = exports.waitFor = void 0;
async function waitFor(predictor, producer, interval = 0) {
    return new Promise(resolve => {
        const check = () => {
            if (predictor()) {
                resolve(producer());
            }
            else {
                setTimeout(check, interval);
            }
        };
        check();
    });
}
exports.waitFor = waitFor;
function wait(args) {
    return new Promise(resolve => {
        const check = 'for' in args
            ? () => {
                const result = args.for();
                if (result) {
                    resolve(result);
                    return;
                }
                setTimeout(check, args.interval);
            }
            : () => {
                const ready = args.when();
                if (ready) {
                    resolve(args.then());
                    return;
                }
                setTimeout(check, args.interval);
            };
        check();
    });
}
exports.wait = wait;
async function later(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
exports.later = later;
/** @alias `later(ms?)` */
exports.sleep = later;
async function runLater(f, ms) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            try {
                resolve(f());
            }
            catch (e) {
                reject(e);
            }
        }, ms);
    });
}
exports.runLater = runLater;
